export default __webpack_public_path__ + "static/media/indtech-web.76bc8ac2.jpg";